module.exports = __webpack_public_path__ + "media/images/front/no_photo-854eef1cf8292891e30648ef5b0eaf9c.png";